import React, { useState } from "react";

const GOVERNORATES = [
  "Tunis", "Ariana", "Ben Arous", "Manouba", "Béja", "Bizerte", "Gabès",
  "Gafsa", "Jendouba", "Kairouan", "Kasserine", "Kébili", "Le Kef", "Mahdia",
  "Médenine", "Monastir", "Nabeul", "Sfax", "Sidi Bouzid", "Siliana",
  "Sousse", "Tataouine", "Tozeur", "Zaghouan",
];

type FieldProps = {
  id: string;
  name: string;
  label: string;
  type?: string;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
};

const FloatingField: React.FC<FieldProps> = ({
  id,
  name,
  label,
  type = "text",
  required = true,
  value,
  onChange,
}) => {
  const [focused, setFocused] = useState(false);
  const active = focused || value.length > 0;

  return (
    <div className="relative">
      <input
        id={id}
        name={name}
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
className="w-full bg-transparent pt-6 pb-2 text-sm sm:text-base text-gray-900 outline-none peer"      />
      <label
        htmlFor={id}
        className={`absolute left-0 transition-all duration-200 pointer-events-none ${
          active
            ? "top-0.5 text-xs font-semibold text-blue-600 tracking-wide"
: "top-6 text-sm sm:text-base text-gray-400"        }`}
      >
        {label}
      </label>
      <div className="absolute bottom-0 left-0 h-[2px] w-full bg-gray-200">
        <div
          className={`h-full bg-gradient-to-r from-blue-600 to-yellow-400 transition-all duration-300 ${
            active ? "w-full" : "w-0"
          }`}
        />
      </div>
    </div>
  );
};

const Contact: React.FC = () => {
  const [alertVisible, setAlertVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [governorate, setGovernorate] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [govFocused, setGovFocused] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitting(true);

    try {
      const formData = new FormData(event.currentTarget);
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setAlertVisible(true);
        event.currentTarget.reset();
        setName("");
        setEmail("");
        setPhone("");
        setGovernorate("");
        setSubject("");
        setMessage("");

        setTimeout(() => {
          setAlertVisible(false);
        }, 4000);
      } else {
        console.error("Form submission failed:", data.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const govActive = govFocused || governorate.length > 0;

  return (
    <div className="min-h-screen bg-gray-50">

      {/* HERO */}
{/* HERO */}
{/* HERO */}
<div className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen bg-gradient-to-br from-blue-700 via-blue-700 to-blue-900 pt-28 sm:pt-32 md:pt-40 pb-16 sm:pb-20 md:pb-24 px-4 sm:px-6 text-center overflow-hidden">
 <div className="relative z-10 max-w-3xl mx-auto">

          <span className="inline-flex items-center gap-2 text-yellow-400 text-xs font-bold tracking-[0.25em] uppercase mb-4">
            <span className="w-8 h-px bg-yellow-400"></span>
            Parlons-nous
            <span className="w-8 h-px bg-yellow-400"></span>
          </span>

<h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-black text-white mb-6">            Contactez-nous
          </h1>

<p className="text-blue-100/90 text-sm sm:text-base md:text-lg leading-relaxed max-w-2xl mx-auto px-2">
            Contactez notre équipe pour toute demande d'information.
          </p>
<p className="text-blue-100/80 text-xs sm:text-sm md:text-base leading-relaxed max-w-2xl mx-auto mt-2 px-2">
            Que vous soyez un particulier, un professionnel ou un investisseur, J-Tronics vous accompagne dans le choix des solutions de lavage les mieux adaptées à vos besoins.
          </p>
        </div>
      </div>

      {/* MAIN CONTENT */}
<div className="max-w-6xl mx-auto px-4 sm:px-6 mt-10 pb-24">
<div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_350px] xl:grid-cols-[minmax(0,1fr)_380px] rounded-3xl shadow-2xl shadow-blue-900/10 overflow-hidden border border-gray-100">

          {/* FORM PANEL */}
<div className="bg-white p-5 sm:p-8 lg:p-12">            <div className="flex items-center gap-3 mb-9">
              <div className="w-11 h-11 rounded-xl bg-yellow-400 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900">Envoyez-nous un message</h2>
                <p className="text-xs text-gray-500 mt-0.5">Réponse sous 24h ouvrées</p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-7">
              <input
                type="hidden"
                name="access_key"
                value="40df5f58-cb4c-4391-96e5-fb411e430b6a"
              />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-7">
                <FloatingField
                  id="name"
                  name="name"
                  label="Nom complet"
                  value={name}
                  onChange={setName}
                />
                <FloatingField
                  id="email"
                  name="email"
                  label="Votre e-mail"
                  type="email"
                  value={email}
                  onChange={setEmail}
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-7">
                <FloatingField
                  id="phone"
                  name="phone"
                  label="Numéro de téléphone"
                  type="tel"
                  value={phone}
                  onChange={setPhone}
                />

                <div className="relative">
                  <select
                    id="governorate"
                    name="governorate"
                    required
                    value={governorate}
                    onChange={(e) => setGovernorate(e.target.value)}
                    onFocus={() => setGovFocused(true)}
                    onBlur={() => setGovFocused(false)}
                    className="w-full appearance-none bg-transparent pt-6 pb-2 text-base text-gray-900 outline-none cursor-pointer"
                  >
                    <option value="" disabled hidden></option>
                    {GOVERNORATES.map((gov) => (
                      <option key={gov} value={gov}>{gov}</option>
                    ))}
                  </select>
                  <label
                    htmlFor="governorate"
                    className={`absolute left-0 transition-all duration-200 pointer-events-none ${
                      govActive
                        ? "top-0.5 text-xs font-semibold text-blue-600 tracking-wide"
                        : "top-6 text-base text-gray-400"
                    }`}
                  >
                    Gouvernorat
                  </label>
                  <svg
                    className="absolute right-1 top-7 w-4 h-4 text-gray-400 pointer-events-none"
                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <div className="absolute bottom-0 left-0 h-[2px] w-full bg-gray-200">
                    <div
                      className={`h-full bg-gradient-to-r from-blue-600 to-yellow-400 transition-all duration-300 ${
                        govActive ? "w-full" : "w-0"
                      }`}
                    />
                  </div>
                </div>
              </div>

              <FloatingField
                id="subject"
                name="subject"
                label="Sujet"
                value={subject}
                onChange={setSubject}
              />

              <div className="relative">
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full bg-transparent pt-6 pb-2 text-base text-gray-900 outline-none resize-none"
                  placeholder=" "
                />
                <label
                  htmlFor="message"
                  className={`absolute left-0 transition-all duration-200 pointer-events-none ${
                    message.length > 0
                      ? "top-0.5 text-xs font-semibold text-blue-600 tracking-wide"
                      : "top-6 text-base text-gray-400"
                  }`}
                >
                  Message
                </label>
                <div className="absolute bottom-0 left-0 h-[2px] w-full bg-gray-200">
                  <div
                    className={`h-full bg-gradient-to-r from-blue-600 to-yellow-400 transition-all duration-300 ${
                      message.length > 0 ? "w-full" : "w-0"
                    }`}
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="group relative w-full overflow-hidden rounded-xl bg-blue-600 px-6 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-lg shadow-blue-600/30 transition-all duration-300 hover:bg-blue-700 hover:shadow-blue-600/40 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <span className="relative z-10 flex items-center justify-center gap-2">
                  {submitting ? "Envoi en cours..." : "Envoyer le message"}
                  {!submitting && (
                    <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </span>
              </button>
            </form>
          </div>

          {/* INFO PANEL */}
<div className="relative bg-gradient-to-br from-blue-700 via-blue-800 to-blue-900 p-5 sm:p-7 flex flex-col overflow-hidden">
                {/* decorative dot grid */}
            <svg className="absolute top-0 right-0 w-48 h-48 opacity-10 pointer-events-none" viewBox="0 0 200 200">
              {Array.from({ length: 8 }).map((_, row) =>
                Array.from({ length: 8 }).map((_, col) => (
                  <circle key={`${row}-${col}`} cx={col * 26 + 10} cy={row * 26 + 10} r="2" fill="#ffffff" />
                ))
              )}
            </svg>

            

            <div className="space-y-5 flex-1">

              {/* Heures */}
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-yellow-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                    <path d="M12 7V12L15 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest text-blue-200/70 mb-1">Heures de bureau</p>
                  <p className="text-sm text-white font-medium">Lundi – Vendredi : 08:30 – 17:00</p>
                  <p className="text-sm text-white font-medium">Samedi : 08:30 – 13:00</p>
                </div>
              </div>

              <div className="h-px bg-white/10"></div>

              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-yellow-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest text-blue-200/70 mb-1">Email</p>
                  <a
                    href="mailto:commercial@jtronics.org"
                    className="text-sm font-semibold text-white hover:text-yellow-400 transition-colors"
                  >
                    commercial@jtronics.org
                  </a>
                </div>
              </div>

              <div className="h-px bg-white/10"></div>

              {/* Téléphone */}
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-yellow-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest text-blue-200/70 mb-1">Téléphone</p>
                  <a
                    href="tel:+21626800203"
                    className="text-sm font-semibold text-white hover:text-yellow-400 transition-colors"
                  >
                    +216 26 800 203
                  </a>
                </div>
              </div>
            </div>
            {/* Localisation */}
<div className="flex items-start gap-4">
  <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
    <svg className="w-5 h-5 text-yellow-400" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 22s7-4.5 7-11a7 7 0 10-14 0c0 6.5 7 11 7 11z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="11" r="2.5" stroke="currentColor" strokeWidth="2" />
    </svg>
  </div>

  <div className="w-full">
    <p className="text-xs font-bold uppercase tracking-widest text-blue-200/70 mb-2">
      Localisation
    </p>

    {/* MAP EMBED */}
    <div className="rounded-xl overflow-hidden border border-white/10">
      <iframe
        title="J-Tronics Location"
        src="
        https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3266.913981601747!2d10.90759747441631!3d35.03388176526522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301c136d2d11a4b%3A0x32a3cf4761c2c5a4!2zU29jacOpdMOpIEotVHJvbmljcw!5e0!3m2!1sfr!2stn!4v1781537148214!5m2!1sfr!2stn"
        width="100%"
        height="180"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </div>
</div>

            <div className="relative mt-6 pt-5 border-t border-white/10">
              <p className="text-xs text-blue-200/60 leading-relaxed">
                J-Tronics — Solutions de lavage automobile, Djebeniana, Tunisie.
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* SUCCESS ALERT */}
      {alertVisible && (
        <div className="fixed bottom-6 inset-x-0 px-4 z-50">
<div className="w-full max-w-md mx-auto bg-white rounded-2xl shadow-2xl border border-green-100 overflow-hidden">
                <div className="h-1 bg-green-500 w-full"></div>
            <div className="flex items-center gap-4 px-5 py-4">
              <div className="w-10 h-10 rounded-xl bg-green-100 flex items-center justify-center flex-shrink-0">
                <svg className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="flex-1 text-sm font-medium text-gray-800">
                Le message a été envoyé avec succès. Nous vous contacterons bientôt.
              </p>
              <button
                onClick={() => setAlertVisible(false)}
                className="flex-shrink-0 w-7 h-7 rounded-lg bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
              >
                <svg className="h-4 w-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;